import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import PromiseContainer from '../../components/data/PromiseContainer';
import { Title } from '../../components/display';
import { Page } from '../../components/surfaces';
import { useIsAdmin, useStore } from '../../store';
import usePromise from '../../store/utils/usePromise';
import { onError, onSuccess } from '../../utils/errors';
import ECommerceWidget from './ecommerce';
import GeneralForm from './GeneralForm';
import StorageWidget from './storage/StorageWidget';
import Account from './store/Account';

export default observer(function AccountPage() {
  const { accountStore } = useStore();
  const [accountPromise] = usePromise(() => accountStore.fetchAccount());

  useNotifyOnWebhook();

  return (
    <Page surface="empty">
      <PromiseContainer promise={accountPromise}>
        {(account) => <AccountForm account={account} />}
      </PromiseContainer>
    </Page>
  );
});

const AccountForm = observer(function AccountForm({
  account,
}: {
  account: Account;
}) {
  const isAdmin = useIsAdmin({ mode: 'any' });
  const showStorage = !account.configurations.managedStorage || isAdmin;
  const showECommerce = account.isWebhookEnabled;

  return (
    <div>
      <GeneralForm account={account} />
      {(showStorage || showECommerce) && (
        <Title sx={{ ml: 2 }}>Integrations</Title>
      )}
      {showStorage && <StorageWidget account={account} />}
      {showECommerce && <ECommerceWidget account={account} />}
    </div>
  );
});

function useNotifyOnWebhook() {
  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const success = currentUrl.searchParams.get('success');
    const error = currentUrl.searchParams.get('error');

    if (success) {
      onSuccess(success);
    } else if (error) {
      onError(new Error(error));
    }
  }, []);
}
